"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBicycleNumberInvalid = exports.isTwoWheelNumberInvalid = exports.isCarNumberInvalid = exports.twoWheelNumberValidation = exports.bicycleNumberValidation = exports.carNumberValidation = void 0;
/*
 * Copyright Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const project_config_1 = __importDefault(require("../../../config/project.config"));
const surveyHelperNew = __importStar(require("../../../utils/helpers"));
const getMaxHouseholdAssetCount = (householdSize, maxPerPerson) => householdSize * maxPerPerson;
/**
 * Household size used for asset count upper bounds.
 * Falls back to {@link projectConfig.maxHouseholdSize} when size is unknown or invalid.
 * @param householdSize number of people in the household, if known
 */
const getEffectiveHouseholdSizeForAssetCount = (householdSize) => {
    if (householdSize !== undefined && Number.isInteger(householdSize) && householdSize > 0) {
        return householdSize;
    }
    return project_config_1.default.maxHouseholdSize;
};
/**
 * Whether a household asset count is invalid for audits and server-side checks.
 * @param value asset count on the household
 * @param householdSize number of people in the household
 * @param maxPerPerson maximum count allowed per household member
 */
const isHouseholdAssetCountInvalid = (value, householdSize, maxPerPerson) => {
    if (value === undefined) {
        return false;
    }
    if (!Number.isInteger(value) || value < 0) {
        return true;
    }
    return value > getMaxHouseholdAssetCount(getEffectiveHouseholdSizeForAssetCount(householdSize), maxPerPerson);
};
const getHouseholdSizeFromInterview = (interview) => {
    const householdSize = surveyHelperNew.getResponse(interview, 'household.size', undefined);
    if ((0, LodashExtensions_1._isBlank)(householdSize) || isNaN(Number(householdSize)) || typeof householdSize !== 'number') {
        return undefined;
    }
    return householdSize;
};
/**
 * Build a widget validation for a household asset count (cars, bicycles, two-wheelers).
 * The upper bound is household size (or maxHouseholdSize when size is unknown) × maxPerPerson.
 *
 * Widgets should define a `conditional` that hides the asset input until `household.size`
 * is completed and valid (integer ≥ 1), so participants answer household size first.
 *
 * @param maxPerPerson maximum count allowed per household member
 * @param messageKeys i18n keys under `survey:errors` for validation messages
 */
const createHouseholdAssetCountValidation = (maxPerPerson, messageKeys) => {
    return (value, _customValue, interview, _path, _customPath) => {
        const householdSize = getHouseholdSizeFromInterview(interview);
        const maxTotal = getMaxHouseholdAssetCount(getEffectiveHouseholdSizeForAssetCount(householdSize), maxPerPerson);
        return [
            {
                validation: !(0, LodashExtensions_1._isBlank)(value) && (isNaN(Number(value)) || !Number.isInteger(Number(value))),
                errorMessage: (t) => t(messageKeys.invalid)
            },
            {
                validation: (0, LodashExtensions_1._isBlank)(value),
                errorMessage: (t) => t(messageKeys.required)
            },
            {
                validation: Number(value) < 0,
                errorMessage: (t) => t(messageKeys.minZero)
            },
            {
                validation: Number(value) > maxTotal,
                errorMessage: (t) => t(messageKeys.overMax, { maxPerPerson })
            }
        ];
    };
};
/** @see {@link ValidationFunction} */
exports.carNumberValidation = createHouseholdAssetCountValidation(project_config_1.default.vehicles.maxCarsPerHouseholdMember, {
    invalid: 'survey:errors:carNumberInvalid',
    required: 'survey:errors:carNumberRequired',
    minZero: 'survey:errors:carNumberMinZero',
    overMax: 'survey:errors:carNumberOverMax'
});
/** @see {@link ValidationFunction} */
exports.bicycleNumberValidation = createHouseholdAssetCountValidation(project_config_1.default.vehicles.maxBicyclesPerHouseholdMember, {
    invalid: 'survey:errors:bicycleNumberInvalid',
    required: 'survey:errors:bicycleNumberRequired',
    minZero: 'survey:errors:bicycleNumberMinZero',
    overMax: 'survey:errors:bicycleNumberOverMax'
});
/** @see {@link ValidationFunction} */
exports.twoWheelNumberValidation = createHouseholdAssetCountValidation(project_config_1.default.vehicles.maxTwoWheelsPerHouseholdMember, {
    invalid: 'survey:errors:twoWheelNumberInvalid',
    required: 'survey:errors:twoWheelNumberRequired',
    minZero: 'survey:errors:twoWheelNumberMinZero',
    overMax: 'survey:errors:twoWheelNumberOverMax'
});
/** Whether car number fails participant validation rules for the given household size. */
const isCarNumberInvalid = (carNumber, householdSize) => isHouseholdAssetCountInvalid(carNumber, householdSize, project_config_1.default.vehicles.maxCarsPerHouseholdMember);
exports.isCarNumberInvalid = isCarNumberInvalid;
/** Whether two-wheel number fails participant validation rules for the given household size. */
const isTwoWheelNumberInvalid = (twoWheelNumber, householdSize) => isHouseholdAssetCountInvalid(twoWheelNumber, householdSize, project_config_1.default.vehicles.maxTwoWheelsPerHouseholdMember);
exports.isTwoWheelNumberInvalid = isTwoWheelNumberInvalid;
/**
 * Whether a bicycle count fails participant validation for the given household size.
 * Regular and electric counts share {@link projectConfig.vehicles.maxBicyclesPerHouseholdMember}:
 * a bicycle is a bicycle.
 */
const isBicycleNumberInvalid = (bicycleNumber, householdSize) => isHouseholdAssetCountInvalid(bicycleNumber, householdSize, project_config_1.default.vehicles.maxBicyclesPerHouseholdMember);
exports.isBicycleNumberInvalid = isBicycleNumberInvalid;
//# sourceMappingURL=householdAssetCountValidation.js.map